import React, { useState, useEffect, useRef } from 'react';
import './contact.css';
import MobileNav from '../common/MobileNav';

const Contact = () => {
  const heroRef = useRef(null);

  const [scrollProgress, setScrollProgress] = useState(0);
  const [showBackToTop, setShowBackToTop] = useState(false);

  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: ''
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    usage: '',
    description: ''
  });


  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Parallax effect
          if (heroRef.current) {
            const scrolled = window.pageYOffset;
            heroRef.current.style.transform = `translateY(${scrolled * 0.4}px)`;
          }

          // Scroll progress
          const windowHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          const scrollTop = window.pageYOffset;
          const progress = (scrollTop / (documentHeight - windowHeight)) * 100;
          setScrollProgress(progress);

          // Back to top button
          setShowBackToTop(scrollTop > 300);

          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.3 }
    );

    const statCards = document.querySelectorAll('.contact-stat-card');
    const infoCards = document.querySelectorAll('.contact-info-card');

    statCards.forEach((card) => observer.observe(card));
    infoCards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const stats = [
    {
      value: '5',
      label: 'Success in getting happy customer',
      suffix: '+'
    },
    {
      value: '5',
      label: 'Successful business',
      suffix: '+'
    },
    {
      value: '6',
      label: 'Total clients who love Elexyt',
      suffix: '+'
    },
    {
      value: '4',
      label: 'Stars reviews given by satisfied clients',
      suffix: '★'
    }
  ];

  const contactInfo = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      title: 'Address',
      detail: 'Bangalore, Karnataka',
      link: '#'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      ),
      title: 'Call Us',
      detail: '080 4169 2763',
      link: 'tel:08041692763'
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      ),
      title: 'Email Us',
      detail: 'info@elexyt.com',
      link: 'mailto:info@elexyt.com'
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Button loading state
    const submitButton = e.target.querySelector('button');
    const originalText = submitButton.innerHTML;

    submitButton.innerHTML = `
    <span style="display:flex;align-items:center;gap:.5rem;">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" class="spinner-icon">
        <circle cx="12" cy="12" r="10" opacity="0.25"/>
        <path d="M12 2a10 10 0 0 1 10 10" opacity="0.75"/>
      </svg>
      Sending...
    </span>
  `;
    submitButton.disabled = true;

    try {
      const payload = {
        access_key: 'ffe9b71b-4e54-41ed-bb2a-c52a8b9d9ce4',
        subject: 'New Contact Form Submission',
        from_name: 'Elexyt Contact Page',

        name: formData.name,
        email: formData.email,
        Phone: formData.phone,
        usage: formData.usage,

        message: `
New Contact Enquiry Received

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Usage Type: ${formData.usage}

Message:
${formData.description}
      `.trim()
      };

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || 'Submission failed');
      }

      // Success toast
      setToast({
        show: true,
        message: 'Your message was sent successfully! We’ll get back to you shortly.',
        type: 'success'
      });

      // Reset form
      setFormData({
        name: '',
        email: '',
        usage: '',
        description: ''
      });

    } catch (error) {
     
      setToast({
        show: true,
        message: 'Failed to send message. Please try again later.',
        type: 'error'
      });
    } finally {
      submitButton.innerHTML = originalText;
      submitButton.disabled = false;

      setTimeout(() => {
        setToast({ show: false, message: '', type: '' });
      }, 5000);
    }
  };


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {/* Scroll Progress Bar */}
      <div className="scroll-progress" style={{ width: `${scrollProgress}%` }} />
      <div className="contact">
        {/* Hero Section */}
        <section className="contact-hero">
          <div className="contact-hero-background" ref={heroRef}>
            <div className="contact-hero-pattern"></div>
            <div className="contact-hero-gradient"></div>
          </div>

          <div className="container">
            <div className="contact-hero-content">
              <div className="contact-hero-badge-wrapper">
                <span className="contact-hero-badge">
                  <span className="badge-dot"></span>
                  Let's Connect
                </span>
              </div>

              <h1 className="contact-hero-title">
                Get in
                <span className="contact-hero-title-gradient"> Touch</span>
              </h1>

              <p className="contact-hero-description">
                Have a project in mind? We'd love to hear from you. Reach out and let's create something exceptional together.
              </p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="contact-stats-section">
          <div className="container">
            <div className="contact-stats-wrapper">
              {stats.map((stat, index) => (
                <div key={index} className="contact-stat-card">
                  <div className="contact-stat-value">{stat.value}{stat.suffix}</div>
                  <div className="contact-stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        <section className="contact-info-section">
          <div className="container">
            <div className="contact-section-header centered">
              <div className="contact-section-label">
                <span className="label-line"></span>
                <span>Contact Information</span>
                <span className="label-line"></span>
              </div>
              <h2 className="contact-section-title-large">
                Multiple Ways to Reach Us
              </h2>
              <p className="contact-section-subtitle">
                Choose your preferred method of communication and we'll respond promptly
              </p>
            </div>

            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <div key={index} className="contact-info-card">
                  <div className="contact-info-card-inner">
                    <div className="contact-info-icon-wrapper">
                      <div className="contact-info-icon">{info.icon}</div>
                    </div>
                    <h3 className="contact-info-title">{info.title}</h3>
                    <a href={info.link} className="contact-info-detail">
                      {info.detail}
                    </a>
                  </div>
                  <div className="contact-info-card-glow"></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Main Contact Section */}
        <section className="contact-main-section">
          <div className="container">
            <div className="contact-section-header centered">
              <div className="contact-section-label">
                <span className="label-line"></span>
                <span>Send Us A Message</span>
                <span className="label-line"></span>
              </div>
              <h2 className="contact-section-title-large">
                Let's Start a Conversation
              </h2>
              <p className="contact-section-subtitle">
                Fill out the form below and our team will get back to you within 24 hours
              </p>
            </div>

            <div className="contact-content-grid">
              {/* Map */}
              <div className="contact-map-wrapper">
                <div className="contact-map-container">
                  <iframe
                    className="contact-map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124423.50895516337!2d77.63263114327528!3d12.956831052398234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae123958f3a7b7%3A0x76fee74577540643!2sKundalahalli%20Gate!5e0!3m2!1sen!2sin!4v1723120509675!5m2!1sen!2sin"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Elexyt Technologies Location"
                  ></iframe>
                </div>
              </div>

              {/* Contact Form */}
              <div className="contact-form-wrapper">
                <div className="contact-form-container">
                  <div className="contact-form-group">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Your Name"
                      required
                      className="contact-form-input"
                    />
                  </div>

                  <div className="contact-form-group">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Your Email"
                      required
                      className="contact-form-input"
                    />
                  </div>

                  <div className="contact-form-group">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Your Phone Number"
                      required
                      className="contact-form-input"
                    />
                  </div>

                  <div className="contact-form-group">
                    <select
                      name="usage"
                      value={formData.usage}
                      onChange={handleInputChange}
                      required
                      className="contact-form-select"
                    >
                      <option value="" disabled>Select Uses Option</option>
                      <option value="Company">Organisation</option>
                      <option value="Personal">Personal</option>
                    </select>
                  </div>

                  <div className="contact-form-group">
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      rows="5"
                      placeholder="Tell us about your project..."
                      required
                      className="contact-form-textarea"
                    ></textarea>
                  </div>

                  <div className="contact-form-actions">
                    <form onSubmit={handleSubmit}>
                      {/* inputs here */}
                      <button type="submit" className="btn btn-primary btn-large">
                        Send Message
                      </button>
                    </form>

                  </div>

                  <p className="contact-form-note">
                    Your information is secure. We never share your data.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </section>

        {/* Toast Notification */}
        {toast.show && (
          <div className={`toast-notification ${toast.type}`}>
            <div className="toast-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <div className="toast-content">
              <p className="toast-message">{toast.message}</p>
            </div>
            <button className="toast-close" onClick={() => setToast({ show: false, message: '', type: '' })}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        )}
      </div>

      {/* Back to Top Button */}
      <button
        className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="18 15 12 9 6 15" />
        </svg>
      </button>
      <MobileNav />
    </>

  );
};

export default Contact;